import { InputProps } from '../types'
import NumberInputBase from './NumberInputBase'

interface PercentageInputProps extends InputProps {
  min?: number
  max?: number
  step?: number
}

/**
 * Renders a percentage input field with % suffix
 * @returns {JSX.Element} The rendered input component.
 */
export default function PercentageInput({
  onChange,
  invalid,
  errorMessage,
  question,
  min = -Infinity,
  max = Infinity,
  step = 1,
}: PercentageInputProps) {
  return (
    <NumberInputBase
      id={`question-${question.id}`}
      label={question.text}
      value={(question.value as string) ?? ''}
      onChange={onChange}
      min={min}
      max={max}
      step={step}
      required={question.required}
      invalid={!!invalid}
      errorMessage={errorMessage}
      prefix={<span className="text-muted-foreground">%</span>}
    />
  )
}
